<template>
    <div>

        <trax-ui-form :id="id" icons="1" :form="form" :form-extend="formExtend" :action="action" :bus="bus"
            :source="source" :target="target">

            <trax-ui-input type="text" icon="person" :placeholder="lang.polaris.account.username"
                v-model="form.username" v-bind:error="errors.username" :required="!usernameDisabled" :disabled="usernameDisabled || requiredDisabled" v-if="withUsername">
            </trax-ui-input>

            <trax-ui-input type="email" icon="email" :placeholder="lang.polaris.account.email"
                v-model="form.email" v-bind:error="errors.email" :required="!emailDisabled" 
                :disabled="emailDisabled || requiredDisabled">
            </trax-ui-input>

            <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.account.firstname"
                v-model="form.firstname" v-bind:error="errors.firstname" required="1" 
                :disabled="requiredDisabled">
            </trax-ui-input>

            <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.account.lastname"
                v-model="form.lastname" v-bind:error="errors.lastname" required="1"
                :disabled="requiredDisabled">
            </trax-ui-input>

            <trax-ui-input type="text" icon="assignment_ind" placeholder="ENAC ID"
                v-model="form.enac_id" v-bind:error="errors.enac_id"
                :disabled="requiredDisabled">
            </trax-ui-input>

            <trax-ui-select icon="flag" v-model="form.meta.lang" :options="lang_select"
                :disabled="supervisedDisabled" v-if="lang_select.length > 1">
            </trax-ui-select>

            <slot></slot>

            <p class="pt-4 pl-3 mb-0">
                <span class="trax-required">*</span>
                {{ lang.polaris.form.required_fields }}
            </p>

        </trax-ui-form>

    </div>
</template>

<script>
    export default {
    
        props: {
            withUsername: null,
            myProfile: null,
            selfEdit: null,
            formExtend: null,
            disableRequiredFields: null,
            source: {default: '1'},
            target: {default: 'final'}
        },
        
        data: function() {
            return {
                loaded: false,
                id: 'trax-account-user-edit',
                lang: lang,
                user: user,
                lang_select: data.lang_select,
                data: {
                    source: null
                },
                form: {
                    username: '',
                    firstname: '',
                    lastname: '',
                    enac_id: '',
                    email: '',
                    meta: {},
                },
                errors: {},
                action: {
                    align: 'right',
                    label: lang.polaris.form.save
                },
                bus: this.$bus
            }
        },

        computed: {

            usernameDisabled() {
                return this.myProfile || this.selfEdit ? true : null;
            },

            emailDisabled() {
                return !this.withUsername && (this.myProfile || this.selfEdit) ? true : null;
            },

            canManage() {
                return this.user.admin || this.user.permissions['user.manage'] ? true : false;
            },

            // The supervisors only change the phone, the birth date and the medical
            // certificate of an account: everything else is read-only for them.
            // Own profile is not concerned: it has its own restrictions.
            supervisedDisabled() {
                return !this.myProfile && !this.canManage ? true : false;
            },

            requiredDisabled() {
                return (this.myProfile && this.disableRequiredFields) || this.supervisedDisabled;
            },
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-data', function(data) {
                that.selectData(data);
                that.loaded = true;
            });

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });
        },

        methods: {

            selectData(data) {
                this.data = data;
                for (var index in this.form) {
                    this.form[index] = data[index];
                }
            }
        }
    }
</script>
